import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  loadingKeys: [],
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    addLoadingKey(state, action) {
      if (!state.loadingKeys.includes(action.payload)) {
        state.loadingKeys.push(action.payload);
      }
    },
    removeLoadingKey(state, action) {
      state.loadingKeys = state.loadingKeys.filter((key) => key !== action.payload);
    },
  },
});

export const uiActions = uiSlice.actions;

export default uiSlice.reducer;
